import React from "react";

const GSMCalculator = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        title="GSM Calculator"
        src="https://costing.rupioo.com/"
        style={{ width: "100%", height: "100%", border: "0" }}
        allow="clipboard-read; clipboard-write; fullscreen"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads"
      />
    </div>
  );
};

export default GSMCalculator;
